// extracted by mini-css-extract-plugin
export var dropdownContainer = "_s9-0";
export var leftAlign = "_s9-4";
export var listItem = "_s9-2";
export var listItemWrapper = "_s9-1";
export var operationText = "_s9-3";